import {WithIdSchema} from './api/definitions';
import {ObjectIdSchema} from './zod';
import {z} from 'zod';
import {AccountFilterSchema} from './filter/accountFilter';
import {ObjectId} from 'bson';

export const MaxTagsLimit = 100;

export const TagTypeSchema = z.enum(['static', 'dynamic']);
export type TagType = z.infer<typeof TagTypeSchema>;

export const TagTypeLabel = {
  dynamic: 'Dynamic',
  static: 'Static',
} satisfies Record<TagType, string>;

const TagBaseSchema = z.object({
  customerId: ObjectIdSchema,
  timestamp: z.date(),
  name: z.string(),
  deleted: z.boolean().optional(),
});

export const StaticTagSchema = TagBaseSchema.extend({
  type: z.literal('static'),
});
export type StaticTag = z.infer<typeof StaticTagSchema>;

export const DynamicTagSchema = TagBaseSchema.extend({
  type: z.literal('dynamic'),
  filter: AccountFilterSchema,
});
export type DynamicTag = z.infer<typeof DynamicTagSchema>;

export const TagSchema = z.discriminatedUnion('type', [
  StaticTagSchema,
  DynamicTagSchema,
]);
export type Tag = z.infer<typeof TagSchema>;

const StaticTagResponseSchema = StaticTagSchema.extend(WithIdSchema).omit({
  customerId: true,
});

const DynamicTagResponseSchema = DynamicTagSchema.extend(WithIdSchema).omit({
  customerId: true,
});
export type DynamicTagResponse = z.infer<typeof DynamicTagResponseSchema>;

export const TagResponseSchema = z.discriminatedUnion('type', [
  StaticTagResponseSchema,
  DynamicTagResponseSchema,
]);
export type TagResponse = z.infer<typeof TagResponseSchema>;

export const TagAccountPreviewSchema = z.object({
  _id: z.instanceof(ObjectId),
  name: z.string(),
  domain: z.string(),
});

export const TagDetailsResponseSchema = z.object({
  numAccounts: z.number(),
  previewAccounts: z.array(TagAccountPreviewSchema),
});
export type TagDetailsResponse = z.infer<typeof TagDetailsResponseSchema>;
